<template>
  <v-app>
    <v-toolbar app>
      <v-toolbar-title class="headline text-uppercase">
        <span>Trust Generator</span>
        <span class="font-weight-light">v2.0</span>
      </v-toolbar-title>
      <v-spacer></v-spacer>
    </v-toolbar>

    <v-content>
      <v-layout text-xs-center wrap>
        <v-flex xs12>
          <v-img :src="require('./assets/logo.svg')" class="my-3" contain height="200"></v-img>
        </v-flex>

        <v-flex mb-4>
          <h1 class="display-2 font-weight-bold mb-3">Welcome to Trust Generator</h1>
          <p class="subheading font-weight-regular">Generate trusts documents with ease!</p>
        </v-flex>
        <TrustForm/>
      </v-layout>
    </v-content>
  </v-app>
</template>

<script>
import TrustForm from "./components/TrustForm";

export default {
  name: "Trust-Generator",
  components: {
    TrustForm
  },
  data() {
    return {
      //
    };
  }
};
</script>
